import { z } from "zod";

export const getUserInvitationSchema = z.object({
	invitationId: z.string(),
});
